/**
 * @generated SignedSource<<cada2df5e6daa91d57783456593c8397>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type admin_examInfo$data = {
  readonly duration: number;
  readonly endTime: string;
  readonly id: string;
  readonly name: string;
  readonly startTime: string;
  readonly " $fragmentType": "admin_examInfo";
};
export type admin_examInfo$key = {
  readonly " $data"?: admin_examInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"admin_examInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "admin_examInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    }
  ],
  "type": "Exam",
  "abstractKey": null
};

(node as any).hash = "afcecd05a55b8051ea79fc8f20ce699c";

export default node;
